import { useQueryState, parseAsString } from 'nuqs'

export const useRulesSearchQueryState = () => {
  return useQueryState('search', parseAsString.withDefault(''))
}
